import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useSelector } from 'react-redux';
import useAxios from '../hook/useAxios';
import useRouter from '../hook/useRouter';
import { RootState, store, useAppDispatch } from '../store';
import { setFavoriteItem } from '../store/priceSlice';

export const FavoriteBtn = ({ itemId, isFav, type, ga360str }: { itemId: number; isFav: boolean; type: string; ga360str: string }) => {
    const l10n = useSelector((state: RootState) => state.main.l10n);
    const favoriteItem = useSelector((state: RootState) => state.price.favoriteItem);

    const [isFavorite, isFavoriteSet] = useState(isFav);
    const { res, loading, error, fetchData } = useAxios<{ contentId: number }>();
    const dispatch = useAppDispatch();
    const [favorView, favorViewSet] = useState('false');

    const { params, getValue } = useRouter(['favorite', 'favitem']);
    useEffect(() => {
        if (!params) return;
        favorViewSet(getValue('favorite'));

        const [favItemId, isFavItem] = getValue('favitem').split('_');

        if (parseInt(favItemId) === itemId) {
            isFavoriteSet(isFavItem === 'true');
        }
    }, [params]);

    const callApi = (_isFav: boolean) => {
        if (window.isLoginFlag !== 'true') window.GNBLogin();

        (document.activeElement as HTMLElement).blur();

        fetchData({
            method: _isFav ? 'post' : 'delete',
            config: store.getState().main.config,
            l10n: l10n,
            path: `/${store.getState().main.config.service}/v2.0/my/favorite/${type}/${itemId}`,
        }).then((_res) => {
            if (_res) {
                dispatch(setFavoriteItem({ id: itemId, isFavorite: _isFav }));

                toast.dismiss();
                const ti = toast((t) => <FavToast isFav={_isFav} favorView={favorView} l10n={l10n} callFn={callApi} />, {
                    duration: 3000,
                    className: 'gameinfo-toast',
                    position: 'bottom-center',
                });
                setTimeout(() => toast.dismiss(ti), 3500);
            }
        });
    };

    useEffect(() => {
        if (error) {
            toast.dismiss();
            let errTitle = error.msg;
            if (error.errStr === 'exceeded') {
                errTitle = `${l10n['common.exceednumfavsbtn']}`;
            }

            toast(
                (t) => (
                    <div className="toast-wrapper">
                        <span className="toast-title">{errTitle}</span>
                    </div>
                ),
                {
                    duration: 3000,
                    className: 'gameinfo-toast',
                    position: 'bottom-center',
                }
            );
        }
    }, [error]);

    useEffect(() => {
        if (favoriteItem.id === itemId) {
            isFavoriteSet(favoriteItem.isFavorite);
        }
    }, [favoriteItem]);

    return (
        <button
            className={`btn-favorite ${isFavorite ? ' is-active' : ''}`}
            data-id={itemId}
            data-areas={ga360str}
            onClick={() => callApi(!isFavorite)}
        >
            {isFavorite ? '★' : '☆'}
        </button>
    );
};

export const FavToast = ({
    isFav,
    favorView,
    l10n,
    callFn,
}: {
    isFav: boolean;
    favorView: string;
    l10n: { [key: string]: string };
    callFn: (isFav: boolean) => void;
}) => (
    <div className={`toast-wrapper ${isFav || favorView !== 'true' ? '' : 'has-button'}`}>
        <span className="toast-title">{isFav ? l10n['common.addfavs'] : l10n['common.removefavs']}</span>
        {isFav || favorView !== 'true' ? (
            ''
        ) : (
            <button className="toast-cancel" onClick={() => callFn(true)}>
                {l10n['common.cancelaction']}
            </button>
        )}
    </div>
);
